import { ColumnsType } from "antd/es/table";
import { Question } from "@types";
import { Button, Divider, Input, Space, Typography } from "antd";
import { Search } from "lucide-react";
import { Translation } from "react-i18next";
import parse, { domToReact } from 'html-react-parser';

const options = {
  replace: (domNode: any) => {
    if (domNode.name === 'p') {
      // Replace the <p> with a <span>, keeping its children
      return <span>{domToReact(domNode.children)}</span>;
    }
  },
};


export const bankPoolTable: ColumnsType<Question> = [
    {
        title: <Translation>{(t) => t("table.question")}</Translation>,
        dataIndex: "text",
        key: "text",
        filterSearch: true,
        ellipsis: true,
        width: "50%",
        onFilter: (value: any, record) => record.text.toLowerCase().includes(value.toLowerCase()),
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
              <Input
                prefix={<Search style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
                placeholder={<Translation>{(t) => t("pages.bankPool.searchFilter")}</Translation> as any}
                value={selectedKeys[0]}
                onChange={(e) => {
                  setSelectedKeys(e.target.value ? [e.target.value] : []);
                }}
                onPressEnter={() => confirm()}
                style={{ display: "flex", marginBottom: "8px" }}
              />
              <Space>
                <Button type="primary" size="small" onClick={() => confirm()}>
                <Translation>{(t) => t("search")}</Translation>
                </Button>
                <Button
                  size="small"
                  type="dashed"
                  onClick={() => {
                    setSelectedKeys([""]);
                    if (clearFilters !== undefined) {
                      clearFilters();
                    }
                    confirm();
                  }}
                >
                  <Translation>{(t) => t("reset")}</Translation>
                </Button>
              </Space>
            </div>
          ),
        filterIcon: (filtered: boolean) => (
        <Search style={{ color: filtered ? "#F1B80E" : undefined }} />
        ),

        render(value, _) {
            return <Typography.Text>{parse(value, options)}</Typography.Text>
        }
    },
    {
        title: <Translation>{(t) => t("table.author")}</Translation>,
        dataIndex: ["user"],
        width: "20%",
        key: "author",
        render(value, _) {
            return <Typography.Text>{value?.firstName || ''} {value?.lastName || ''}</Typography.Text>
        },
    },
    {
        title: <Translation>{(t) => t("table.questionType")}</Translation>,
        dataIndex: ["questionType", "name"],
        key: "questionType",
        render(value, _) {
            return <Typography.Text>{value}</Typography.Text>
        }
    },
    {
        title: <Translation>{(t) => t("table.categories")}</Translation>,
        dataIndex: "categories",
        key: "categories",
        render(value, _) {
            return <Space split={<Divider type="vertical" style={{ margin: 0 }} />} wrap>
              {value.map((category: any) => (
                <Typography.Link>{category.name}</Typography.Link>
            ))}
            </Space>
        }
    }
]